var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.can('vender.change_employee'))?_c('b-form-select',{attrs:{"options":_vm.getOptions({key: 'employee_id', text: 'Empleado'})},model:{value:(_vm.employee_id),callback:function ($$v) {_vm.employee_id=$$v},expression:"employee_id"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }